function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import { BannerContainer, CloseBtn, TextFrame, InlineLink } from './helpers';
import getPgaTld from '../../getPgaTld';
var pgaTld = getPgaTld();
var BetaBanner = function (_React$Component) {
  _inherits(BetaBanner, _React$Component);
  function BetaBanner(props) {
    _classCallCheck(this, BetaBanner);
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
    _this.state = {
      isClosed: false
    };
    _this.closeBanner = _this.closeBanner.bind(_this);
    return _this;
  }
  BetaBanner.prototype.closeBanner = function closeBanner() {
    this.setState({
      isClosed: true
    });
  };
  BetaBanner.prototype.render = function render() {
    var _props$feedbackFormAn = this.props.feedbackFormAnchor,
      feedbackFormAnchor = _props$feedbackFormAn === undefined ? 'feedback-form-anchor' : _props$feedbackFormAn;
    return this.state.isClosed ? null : React.createElement(BannerContainer, null, React.createElement(CloseBtn, {
      onClick: this.closeBanner
    }), React.createElement(TextFrame, null, 'Welcome to the PGA.org Beta Experience! ', React.createElement(InlineLink, {
      href: '#' + feedbackFormAnchor
    }, 'Let us know what you think'), ' or ', React.createElement(InlineLink, {
      id: 'optout',
      href: 'https://www.' + pgaTld + '/?opt-in=0'
    }, 'switch back'), ' to the previous experience.'));
  };
  return BetaBanner;
}(React.Component);
export { BetaBanner as default };